import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import associateServices from "../../../services";
import FormButton from "../../../components/form-button";
import {toast} from "react-toastify";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import {useSelector} from "react-redux";
import InformationToast from "../../../components/toast/InformationToast";
import Loading from "../../../components/loading";
import RankIcon from "../../../components/rank-icon";

const OfferSettings = () => {

    const {t} = useTranslation()
    const {user} = useSelector(state => state.authenticationReducer)
    const [welcomeRedeem, setWelcomeRedeem] = useState('')
    const [bonusRedeem, setBonusRedeem] = useState('')
    const [affiliate, setAffiliate] = useState('')
    const [loading, setLoading] = useState([])


    useEffect(() => {
         setAffiliate(user?.ref_code || '')
    }, [user?.ref_code])
    const handleWelcomeRedeem = () => {
        console.log('handleWelcomeRedeem = ')

        setLoading(prevState => [...prevState, 'welcome'])
        associateServices.redeemWelcomeBonus({code: welcomeRedeem}).then(res => {
            setLoading(prevState => prevState.filter(i => i !== 'welcome'))
            if (res?.status !== 200)
                return toast(<InformationToast
                    icon={'ti-x'}
                    message={t(`api-notifications.${res?.errors}`)}
                    title={t(`general.error`)}
                />)

            const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))

            associateServices.getWallets({}).then(handleUserWallets)
            return toast.success(t(`api-notifications.${res?.data}`))
        })
    }
    const handleAffiliateCode = () => {
        console.log('handleAffiliateCode = ')

        setLoading(prevState => [...prevState, 'affiliate'])
        associateServices.setAffiliate({code: affiliate}).then(res => {
            setLoading(prevState => prevState.filter(i => i !== 'welcome'))
            if (res?.status !== 200)
                return toast.error(t(`api-notifications.${res?.errors}`))


            return toast.success(t(`api-notifications.${res?.data}`))
        })
    }

    const handleDropRedeem = () => {

        setLoading(prevState => [...prevState, 'drop'])
        associateServices.redeemBonus({code: bonusRedeem}).then(res => {
            setLoading(prevState => prevState.filter(i => i !== 'drop'))
            if (res?.status !== 200)
                return toast(<InformationToast
                    icon={'ti-x'}
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.errors}`)}
                />)
            // return toast.error(t(`api-notifications.${res?.errors}`))

            const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))

            associateServices.getWallets({}).then(handleUserWallets)

            return toast(<InformationToast
                icon={'ti-check'}
                title={t(`general.information`)}
                message={t(`api-notifications.${res?.data}`)}
            />)
            // return toast.success(t(`api-notifications.${res?.data}`))

        })
    }
    return (
        <div
            className="tab-pane fade show active"
            id="tab-1"
            role="tabpanel"
            aria-labelledby="1-tab"
            tabIndex={0}
        >
            {/*<div className="settings">*/}
            {/*    <h3 className="settings__title">*/}
            {/*        {t('settings.offers.drop.title')}*/}

            {/*    </h3>*/}
            {/*    <p className="settings__text">*/}
            {/*        {t('settings.offers.drop.desc')}*/}
            {/*    </p>*/}

            {/*    <div className="settings__form">*/}
            {/*        <div className="row">*/}
            {/*            <div className="col-12 col-md-8 col-lg-12 col-xxl-10">*/}
            {/*                <div className="row">*/}
            {/*                    <div className="col-12 col-xl-8 col-xxl-6">*/}
            {/*                        <div className="form__group">*/}
            {/*                            <label htmlFor="" className="form__label">*/}
            {/*                                {t('settings.offers.drop.code')}*/}
            {/*                                <b>*</b>*/}
            {/*                            </label>*/}
            {/*                            <input*/}
            {/*                                value={bonusRedeem}*/}
            {/*                                onChange={e => setBonusRedeem(e.target.value)}*/}
            {/*                                type="text" className="form__input"/>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="settings__actions">*/}
            {/*        <div className="settings__btns">*/}
            {/*            <FormButton*/}
            {/*                disabled={!bonusRedeem || loading.includes('drop')}*/}
            {/*                loading={loading.includes('drop')}*/}
            {/*                onClick={handleDropRedeem}*/}
            {/*                label={t('settings.offers.drop.submit')}*/}

            {/*            />*/}


            {/*            /!*<button*!/*/}
            {/*            /!*    // onClick={handle}*!/*/}
            {/*            /!*    disabled={user?.email_verified_at || false}*!/*/}
            {/*            /!*    className="settings__btn" type="button">*!/*/}
            {/*            /!*    Save*!/*/}
            {/*            /!*</button>*!/*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="settings">

                <h3 className="settings__title">{t('settings.offers.affiliate.title')}</h3>
                <p className="settings__text">
                    {t('settings.offers.affiliate.desc')}
                </p>

                <div className="settings__form">
                    <div className="row">
                        <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                            <div className="row">
                                <div className="col-12 col-xl-8 col-xxl-6">
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.offers.affiliate.code')}
                                            <b>*</b>
                                        </label>
                                        <input
                                            value={affiliate}
                                            onChange={e => setAffiliate(e.target.value)}
                                            disabled={user?.ref_code}
                                            type="text" className="form__input"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    !user?.ref_code &&
                    <div className="settings__actions">
                        <div className="settings__btns">
                            <FormButton
                                disabled={!affiliate || affiliate === user?.ref_code || loading.includes('affiliate')}
                                loading={loading.includes('welcome')}
                                onClick={handleAffiliateCode}
                                label={t('settings.offers.welcome.submit')}
                            />
                        </div>
                    </div>
                }
            </div>
            {/*<div className="settings">*/}
            {/*    <h3 className="settings__title">{t('settings.offers.welcome.title')}</h3>*/}
            {/*    <p className="settings__text">*/}
            {/*        {t('settings.offers.welcome.desc')}*/}
            {/*    </p>*/}

            {/*    <div className="settings__form">*/}
            {/*        <div className="row">*/}
            {/*            <div className="col-12 col-md-8 col-lg-12 col-xxl-10">*/}
            {/*                <div className="row">*/}
            {/*                    <div className="col-12 col-xl-8 col-xxl-6">*/}
            {/*                        <div className="form__group">*/}
            {/*                            <label htmlFor="" className="form__label">*/}
            {/*                                {t('settings.offers.welcome.code')}*/}
            {/*                                <b>*</b>*/}
            {/*                            </label>*/}
            {/*                            <input*/}
            {/*                                value={welcomeRedeem}*/}
            {/*                                onChange={e => setWelcomeRedeem(e.target.value)}*/}
            {/*                                type="text" className="form__input"/>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*    <div className="settings__actions">*/}
            {/*        <div className="settings__btns">*/}
            {/*            <FormButton*/}
            {/*                disabled={!welcomeRedeem || loading.includes('welcome')}*/}
            {/*                loading={loading.includes('welcome')}*/}
            {/*                onClick={handleWelcomeRedeem}*/}
            {/*                label={t('settings.offers.welcome.submit')}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

        </div>
    )

}

export default OfferSettings
